import { FC } from 'react';
import { useQuery } from 'react-query';
import Cookies from 'js-cookie';
import ClientOnlyWrapper from '../../wrappers/ClientOnlyWrapper';
import HeaderBannerItem from './HeaderBannerItem';
import { bannerService } from '@/services/banner.service';
import { IBannersResponseData } from '@/interfaces/banner.interfcae';

const HeaderBanner: FC = () => {
  const BANNER_URL = 'https://kuchaknig.org/thisday/baners/';
  // https://fantasy-worlds.ru/

  const cookieBannerData = Cookies.get('header-banner');
  let bannerData: IBannersResponseData | undefined = undefined;

  const {
    error,
    data: mainBannerData,
    isFetchedAfterMount,
  } = useQuery({
    queryKey: ['main-banner'],
    queryFn: () => bannerService.getCurrentBannerProd(),
    enabled: !cookieBannerData,
  });

  if (isFetchedAfterMount && !!mainBannerData?.data) {
    //Cookie expires after half day
    Cookies.set('header-banner', JSON.stringify(mainBannerData.data), { expires: 0.5 });
  }

  if (cookieBannerData) {
    bannerData = JSON.parse(String(cookieBannerData));
  }

  return (
    <ClientOnlyWrapper>
      <>
        {bannerData ? (
          <HeaderBannerItem url={bannerData?.url} lfrom={bannerData?.lfrom} file_name_1920={bannerData?.file_name_1920} file_name_450={bannerData?.file_name_450} />
        ) : (
          <>{mainBannerData?.data && <HeaderBannerItem url={mainBannerData?.data.url} lfrom={mainBannerData?.data.lfrom} file_name_1920={mainBannerData?.data.file_name_1920} file_name_450={mainBannerData?.data.file_name_450} />}</>
        )}
      </>
    </ClientOnlyWrapper>
  );
};

export default HeaderBanner;
